import React, { useState } from 'react';
import { 
  Card, Form, Input, Button, 
  Typography, Divider, Row, Col, 
  Avatar, Tag, message
} from 'antd';
import { 
  UserOutlined, MailOutlined, LockOutlined, 
  PhoneOutlined, EditOutlined, SaveOutlined,
  CloseOutlined, TeamOutlined, CrownOutlined
} from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

const verifyUsername = async (username) => {

    try{

        const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
        const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${apiKey}`;

        const payload = {
            contents: [{
                parts: [{
                    text: `Check if the username "${username}" is appropriate and not offensive, vulgar, explicit, suggestive,
                        or a disguised version of inappropriate language (e.g., phonetic tricks or wordplay).
                        Respond ONLY with "true" if the username is 100% clean. Respond "false" if it contains or resembles any inappropriate, offensive, or suggestive language.
                        Do NOT explain. ONLY return "true" or "false"`
                    }]
            }]
        };

        const response = await axios.post(url, payload, {

            headers: { 'Content-Type': 'application/json' }
            
        });

        const resultado = response.data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim();
        return resultado === "true";

    }catch{

        return false;

    }

}

function UserProfile() {

  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  const username = localStorage.getItem('username');
  const email = localStorage.getItem('userEmail');
  const fullName = localStorage.getItem('userFullName');
  const userRole = localStorage.getItem('userRole');
  const isCaller = localStorage.getItem('isCaller') === 'true';
  const zoomName = localStorage.getItem('zoomName');
  const senseiName = localStorage.getItem('senseiName');
  const assignedNumber = localStorage.getItem('userPhone');
  const authToken = localStorage.getItem('authToken');

  const initialValues = {
    username,
    email,
    zoom_name: zoomName || '',
    sensei_name: senseiName || '',
    assigned_number: assignedNumber || ''
  };

  const handleSave = async () => {

    try {
        
      setLoading(true);

      const formValues = form.getFieldsValue();

      if (!formValues.currentPassword) {

        messageApi.error('Debes ingresar tu contraseña actual para realizar cambios');
        return;

      }

      const values = await form.validateFields();

      if (changingPassword && values.password !== values.confirmPassword) {

        messageApi.error('Las contraseñas no coinciden');
        return;
        
      }

      if (values.username !== username) {

        const isValid = await verifyUsername(values.username);

        if (!isValid) {

          messageApi.error('El nombre de usuario no es apropiado. Por favor elige otro.');
          return;

        }

      }
     
      const payload = {
        username: values.username !== username ? values.username : undefined,
        currentPassword: changingPassword ? values.currentPassword : undefined,
        newPassword: changingPassword ? values.password : undefined
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/user/update-profile`, 
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (values.username !== username) {

        localStorage.setItem('username', values.username);

      }

      messageApi.success('Perfil actualizado correctamente');
      setEditing(false);
      setChangingPassword(false);
      
      window.location.reload();

    } catch (err) {

      messageApi.error(err.response?.data?.error || 'Error al actualizar los datos');

    } finally {

      setLoading(false);

    }

  };

  return (

    <>
        {contextHolder}
        <div style={{ 
        padding: '20px', 
        backgroundColor: '#2a2b2b',
        minHeight: "70vh",
        color: 'white'
        }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <Title level={2} style={{ 
            color: '#f49b33', 
            marginBottom: '24px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
            }}>
            <UserOutlined /> Mi Perfil
            </Title>

            <Card bordered={false} style={{ 
            backgroundColor: '#353435',
            borderRadius: '8px',
            marginBottom: '24px'
            }}>
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '24px'
            }}>
                <Avatar 
                size={64} 
                icon={<UserOutlined />} 
                style={{ 
                    backgroundColor: '#f49b33',
                    marginRight: '16px'
                }}
                />
                <div>
                <Title level={3} style={{ color: '#fff', margin: 0 }}>
                    {fullName}
                </Title>
                <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                    <Tag icon={<CrownOutlined />} color={userRole === 'admin' ? 'gold' : 'blue'}>
                    {userRole === 'admin' ? 'Administrador' : 
                    userRole === 'moderator' ? 'Moderador' : 'Miembro'}
                    </Tag>
                    {isCaller && (
                    <Tag icon={<TeamOutlined />} color="#f49b33">Caller</Tag>
                    )}
                </div>
                </div>
            </div>

            <Divider style={{ borderColor: '#444' }} />

            <Form
                form={form}
                layout="vertical"
                initialValues={initialValues}
            >
                <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Form.Item
                    label="Nombre de usuario"
                    name="username"
                    rules={[{ required: true, message: 'Por favor ingresa tu nombre de usuario' }]}
                    >
                    <Input 
                        prefix={<UserOutlined />} 
                        disabled={!editing}
                        style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: editing ? 'white' : '#aaa' }}
                    />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                    label="Correo electrónico"
                    name="email"
                    >
                    <Input 
                        prefix={<MailOutlined />} 
                        disabled 
                        style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: '#aaa' }}
                    />
                    </Form.Item>
                </Col>
                </Row>

                {editing && (
                <>
                    <Divider orientation="left" style={{ borderColor: '#444' }}>Seguridad</Divider>
                    
                    <Row gutter={16}>
                    <Col xs={24}>
                        <Form.Item
                        label="Contraseña actual"
                        name="currentPassword"
                        rules={[{ required: true, message: 'Debes ingresar tu contraseña actual' }]}
                        >
                        <Input.Password 
                            prefix={<LockOutlined />}
                            style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: 'white' }}
                        />
                        </Form.Item>
                    </Col>
                    </Row>

                    {!changingPassword ? (
                    <Button 
                        type="link" 
                        onClick={() => setChangingPassword(true)}
                        style={{ color: '#f49b33', padding: 0 }}
                    >
                        ¿Deseas cambiar tu contraseña?
                    </Button>
                    ) : (
                    <>
                        <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item
                            label="Nueva contraseña"
                            name="password"
                            rules={[{ min: 6, message: 'La contraseña debe tener al menos 6 caracteres' }]}
                            >
                            <Input.Password 
                                prefix={<LockOutlined />} 
                                style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: 'white' }}
                            />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                            label="Confirmar contraseña"
                            name="confirmPassword"
                            dependencies={['password']}
                            rules={[
                                ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                    }
                                    return Promise.reject('Las contraseñas no coinciden');
                                },
                                }),
                            ]}
                            >
                            <Input.Password 
                                prefix={<LockOutlined />} 
                                style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: 'white' }}
                            />
                            </Form.Item>
                        </Col>
                        </Row>
                        <Button 
                        type="link" 
                        onClick={() => setChangingPassword(false)}
                        style={{ color: '#ff4d4f', padding: 0 }}
                        >
                        Cancelar cambio de contraseña
                        </Button>
                    </>
                    )}
                </>
                )}

                {isCaller && (
                <>
                    <Divider orientation="left" style={{ borderColor: '#444' }}>Datos de Caller</Divider>
                    
                    <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item
                        label="Nombre en Zoom"
                        name="zoom_name"
                        >
                        <Input 
                            prefix={<UserOutlined />} 
                            disabled
                            style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: '#aaa' }}
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                        label="Nombre de Sensei"
                        name="sensei_name"
                        >
                        <Input 
                            prefix={<UserOutlined />} 
                            disabled
                            style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: '#aaa' }}
                        />
                        </Form.Item>
                    </Col>
                    </Row>
                    
                    <Form.Item
                    label="Número asignado"
                    name="assigned_number"
                    >
                    <Input 
                        prefix={<PhoneOutlined />} 
                        disabled
                        style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: '#aaa' }}
                    />
                    </Form.Item>
                </>
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                {editing ? (
                    <>
                    <Button 
                        type="default" 
                        icon={<CloseOutlined />} 
                        onClick={() => {
                        form.resetFields();
                        setEditing(false);
                        setChangingPassword(false);
                        }}
                        style={{ backgroundColor: '#2a2b2b', borderColor: '#444', color: 'white' }}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        type="primary" 
                        icon={<SaveOutlined />} 
                        onClick={handleSave}
                        loading={loading}
                        style={{ backgroundColor: '#f49b33', borderColor: '#f49b33' }}
                    >
                        Guardar cambios
                    </Button>
                    </>
                ) : (
                    <Button 
                    type="primary" 
                    icon={<EditOutlined />} 
                    onClick={() => setEditing(true)}
                    style={{ backgroundColor: '#f49b33', borderColor: '#f49b33' }}
                    >
                    Editar perfil
                    </Button>
                )}
                </div>
            </Form>
            </Card>
        </div>
        </div>
    </>
  );

}

export default UserProfile;